//引入路由
import VueRouter from "vue-router";

import { getToken } from "@/utils/auth";

import Login from "@/views/Login";
import Home from "@/views/Home";
import Dashboard from "@/views/Dashboard";
import UserAdm from '@/views/UserAdm.vue';
import Setting from "@/views/Setting.vue";
import OrderAdm from '@/views/OrderAdm.vue';
import GoodAdm from "@/views/GoodAdm.vue";
import ClassifyAdm from "@/views/ClassifyAdm.vue";
import ShowsAdm from "@/views/ShowsAdm.vue";

const router = new VueRouter({
  routes: [
    { path: "/", redirect: "login" },
    {
      path: "/login",
      component: Login,
      meta: { is: true, title: "小程序后台管理" },
    },
    {
      path: "/",
      component: Home,
      children: [
        {
          path: "dashboard",
          component: Dashboard,
          meta: { title: "系统首页", isAust: true },
        },
        {
          path: "userAdm",
          component: UserAdm,
          meta: { title: "用户管理", isAust: true },
        },
        {
          path: "goodAdm",
          component: GoodAdm,
          meta: { title: "商品管理", isAust: true },
        },
        {
          path: "orderAdm",
          component: OrderAdm,
          meta: { title: "订单管理", isAust: true },
        },
        {
          path: "showsAdm",
          component: ShowsAdm,
          meta: { title: "买家秀", isAust: true },
        },
        {
          path: "classifyAdm",
          component: ClassifyAdm,
          meta: { title: "分类管理", isAust: true },
        },
        {
          path: "setting",
          component: Setting,
          meta: { title: "系统设置", isAust: true },
        }
      ],
    },
  ],
});

//全局前置路由守卫----初始化的时候被调用,每次路由切换之前被调用  这个可以限制访问路由组件
router.beforeEach((to, form, next) => {
  if (to.meta.is) {
    if (getToken()) {
      next("/dashboard");
    } else {
      next();
    }
  } else {
    next();
  }

  if (to.meta.isAust) {
    if (getToken()) {
      next();
    } else {
      next("/login");
    }
  } else {
    next();
  }
});

//全局后置路由守卫---初始化的时候被调用,每次路由切换之后被调用 这个可以用来切换网页的标题
router.afterEach((to, form) => {
  if (to.meta.title) {
    //切换网页标题
    document.title = to.meta.title;
  } else {
    document.title = "共享储物柜后台";
  }
});
export default router;
